exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input_TextBox {\n  font-family: \"GlacialIndifference-Regular\";\n  font-weight: lighter;\n  border-width: 0px;\n  border: 1px solid black;\n  border-radius: 6px;\n  letter-spacing: 1px;\n  line-height: 19px;\n  font-size: 14px;\n  padding: 8px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-right: 10px;\n}\n\n.input_TextBox:focus {\n  border: 1px solid var(--primary);\n  outline: none;\n  box-shadow: 0 0 3px 2px rgba(0,180,210,0.38);\n}\n", ""]);

// exports
